<!-- <button (click)="openDialogexport()">Export</button> -->
<div class="container-fluid page" *ngIf="maincontent">
  <div class="d-flex page__box p-3 mt-2">
    &nbsp;&nbsp; Blogs
    <div class="export_csv">
      <button
        class="add_button_new"
        (click)="formPage()"
        mat-raised-button
        color="primary"
      >
        Add Blog Post</button
      >&nbsp;&nbsp;
      <button
        class="clear_button_export"
        style="float: right"
        (click)="openDialogexport()"
        mat-raised-button
        color="primary"
      >
        Export
      </button>
    </div>
  </div>
  <div class="page__content shadow p-3">
    <div>
      <br />
      <div class="row" style="margin-top: -40px">
        <div class="col-3 topData">
          <p>Total Blogs Published</p>
          <p style="font-size: 2rem">{{ blogcount }}</p>
        </div>
        <div class="col-3 topData">
          <p>Published This Month</p>
          <p style="font-size: 2rem">{{ blogcountmonth }}</p>
        </div>
        <div class="col-9 pull-right">
          <!-- <button class="clear_button" (click)="formPage()" mat-raised-button color="primary">Add New
                          Scheme</button> -->
        </div>
      </div>
      <mat-card>
        <div class="example-header">
          <mat-form-field style="width: 50% !important">
            <input
              matInput
              [(ngModel)]="searchdata"
              (change)="changeFn($event)"
              placeholder="Search"
            /> </mat-form-field
          >&nbsp;&nbsp;<button
            type="submit"
            (click)="applyfilter(true)"
            class="btn btn-primary mat-primary search_bar"
          >
            <mat-icon class="search_bar_icon">search</mat-icon>
          </button>
          <hr />
          <mat-form-field>
            <mat-select placeholder="Category" [(ngModel)]="category">
              <mat-option
                *ngFor="let opt of maincategory"
                [value]="opt.categoryName"
              >
                <!-- <img with="20" height="20" [src]="opt.imageURL" /> -->
                {{ opt.categoryName }}
              </mat-option>
            </mat-select> </mat-form-field
          >&nbsp;&nbsp;
          <mat-form-field>
            <mat-label>Language</mat-label>
            <mat-select [(ngModel)]="languageName">
              <mat-option
                *ngFor="let language of languageList"
                [value]="language.value"
              >
                {{ language.viewValue }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <button
            class="btn btn-primary mat-primary clear_button pull-right"
            style="margin-top: 12px"
            (click)="clearFilter()"
          >
            Clear Filter
          </button>
          <button
            type="submit"
            style="margin-top: 12px; margin-right: 10px"
            (click)="applyfilter(true)"
            class="btn btn-primary mat-primary pull-right"
          >
            Apply Filter
          </button>
          <mat-chip-list #chipList aria-label="Filter selection">
            <mat-chip
              *ngFor="let filter of matChipArray; let i = index"
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(i, filter.tag)"
            >
              {{ filter.name }}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>

          <div class="text_filter_data" *ngIf="exportcsvdata">
            <p *ngIf="this.userlist.length == 0">
              There's no record found with the given criteria, please try again
              refining your search and filters
            </p>
          </div>

          <!-- <mat-form-field>
                    <input matInput  placeholder="Mobile" (keyup)="filtermobile($event.target.value)">
                  </mat-form-field>&nbsp; -->
        </div>
      </mat-card>
      <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
        <mat-table #table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Title
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">{{ userlist.title }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="imageUrl">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              imageUrl
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">{{ userlist.title }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="thumbnail">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Thumbnail
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              <img
                [src]="userlist.imageUrl"
                style="width: 50px; height: 50px"
              />
            </mat-cell>
          </ng-container>
          <!-- (click)="openDialog(userlist)" -->
          <!-- Weight Column -->
          <!-- <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Type
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              {{ userlist.type }}
            </mat-cell>
          </ng-container> -->
          <!-- Symbol Column -->
          <ng-container matColumnDef="category">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Category
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              <span class="categoryList">{{ userlist.category }}</span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="languages">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Language
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              {{ getLanguages(userlist.language) }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="datepublished">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Date Published
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              {{ userlist.datepublished.split(" ")[0] }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="lastmodifieddate">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Last Modified
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              {{
                userlist.lastmodifieddate.split(" ")[0] === "01/01/0001"
                  ? "Not Modified"
                  : userlist.lastmodifieddate.split(" ")[0]
              }}
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="likes">
            <mat-header-cell *matHeaderCellDef> Likes </mat-header-cell>
            <mat-cell *matCellDef="let userlist">{{ userlist.likes }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
              Action
            </mat-header-cell>
            <mat-cell *matCellDef="let userlist">
              <div>
                <!--(click)="edit(userlist)"-->
                <mat-icon class="colorchange" (click)="edit(userlist.id)"
                  >edit</mat-icon
                >&nbsp;&nbsp;&nbsp;
                <mat-icon class="colorchange" (click)="openDialog(userlist.id)"
                  >delete</mat-icon
                >
              </div>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          <!-- <mat-row style="cursor: pointer;" *matRowDef="let userlist; columns: displayedColumns;"></mat-row> -->
        </mat-table>
        <mat-paginator
          [length]="length"
          [pageIndex]="pageIndex"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 20, 50, 100]"
          (page)="getServerData($event)"
          showFirstLastButtons
          aria-label=""
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
<div *ngIf="pageEvent">
  <h5>Page Change Event Properties</h5>
  <div>List length: {{ pageEvent.length }}</div>
  <div>Page size: {{ pageEvent.pageSize }}</div>
  <div>Page index: {{ pageEvent.pageIndex }}</div>
</div>
<!---==============================edit data html =================================================-->
<div class="container-fluid page" *ngIf="formdataedit">
  <div class="d-flex page__box p-3 mt-2">
    <img
      src="./assets/arrow_logo.png"
      class="arrow"
      (click)="listPage()"
    />&nbsp;&nbsp;Edit Blog Post
  </div>
  <div class="profile_details">
    <div class="page__content shadow p-3">
      <div class="row" style="justify-content: space-between !important">
        <div class="col-md-8">
          <form [formGroup]="form">
            <input [(ngModel)]="iddata" type="hidden" formControlName="id" />
            <div class="example-header" style="padding: 10px 0 0">
              <mat-form-field style="width: 31%">
                <mat-select
                  placeholder="Category"
                  formControlName="categorydata"
                >
                  <mat-option
                    *ngFor="let opt of maincategory"
                    [value]="opt.categoryID"
                  >
                    <img with="20" height="20" [src]="opt.imageURL" />
                    {{ opt.categoryName }}
                  </mat-option>
                </mat-select> </mat-form-field
              >&nbsp;
              <mat-form-field style="width: 31%">
                <mat-label>Languages</mat-label>
                <mat-select
                  [(ngModel)]="languageData"
                  formControlName="languages"
                >
                  <mat-option
                    *ngFor="let language of languageList"
                    [value]="language.value"
                  >
                    {{ language.viewValue }}
                  </mat-option>
                </mat-select> </mat-form-field
              >&nbsp;

              <mat-form-field class="full-width-field">
                <input
                  matInput
                  [(ngModel)]="title"
                  formControlName="titledata"
                  placeholder="Blog title"
                />
              </mat-form-field>
              <div class="row">
                <div class="col-sm-9">
                  <span>
                    <div class="file-upload-header">Thumbnail image</div>
                    <input
                      type="file"
                      name="image"
                      class="file-input"
                      (change)="blogFileSelected($event)"
                      #fileUpload
                    />
                    <button class="file-upload" (click)="fileUpload.click()">
                      <mat-icon>cloud_upload</mat-icon>
                    </button>
                  </span>
                  <!-- <div
                    *ngIf="f['image'].touched && f['image'].invalid"
                    style="font-size: 1rem"
                  >
                    <mat-error
                      *ngIf="f['image'].errors && f['image'].errors['required']"
                      >Image is required.</mat-error
                    >
                  </div> -->
                  &nbsp;&nbsp;
                </div>
                <div class="col-sm-3">
                  <img
                    [src]="imageSrc ? imageSrc : image"
                    class="gallery_images"
                    alt=""
                    accept="image/*"
                  />
                </div>
              </div>
            </div>

            <!-- <ckeditor [editor]="editor" [(ngModel)]="name"></ckeditor> -->
            <!-- </form> -->
            <div style="margin-top: 5px" class="editor">
              <ckeditor
                class="ck-editor__editable"
                [(ngModel)]="name"
                formControlName="ckeditordata"
                name="myckeditor"
                required
                [config]="ckeConfig"
                debounce="500"
              >
              </ckeditor>
            </div>

            <!-- <mat-form-field style="width: 100%;;">
              <input matInput formControlName="remark" autocomplete="off" placeholder="Remarks">
            </mat-form-field><br> -->
            <!-- <div style="float: right; margin-top:-20px">
               <button type="submit" mat-raised-button class="submit_button" color="primary"
                (click)="resetButton()">Reset</button>&nbsp; 
              <button type="submit" class="submit_button" mat-raised-button color="primary" (click)="onSubmit()">Publish</button>
            </div> -->
          </form>
        </div>

        <div class="col-md-4">
          <div class="d-flex row page__box_image p-2 mt-2" style="color: white">
            <div class="col-md-8 col-sm-8">
              <span>Image Gallery</span>
            </div>

            <div class="col-md-4 col-sm-4 pull-right;">
              <div style="float: right">
                <button
                  type="file"
                  onclick="document.getElementById('getFile').click()"
                  class="add_image"
                >
                  <mat-icon style="font-size: 30px">control_point</mat-icon>
                </button>
                <input
                  type="file"
                  id="getFile"
                  multiple
                  (change)="processImage($event)"
                  type="file"
                  #inputFile
                  style="display: none"
                />&nbsp;
                <mat-icon class="delete_image" (click)="deleteImage()"
                  >delete</mat-icon
                >
              </div>
            </div>
          </div>

          <div
            class="d-flex row page__box_image p-2"
            style="
              margin-bottom: 10px;
              color: black;
              background: #efefadc2;
              margin-top: 15px;
            "
          >
            <div class="col-md-1 col-sm-1" style="padding: 0">
              <img src="/assets/info.png" style="height: 35px" />
            </div>
            <div class="col-md-11 col-sm-11" style="padding: 0">
              <span class="info_para"
                >Drag and drop Images to insert in blog.</span
              >
            </div>
          </div>

          <div style="background-color: #f4f4f4; height: 95vh">
            <div
              class="container"
              Style="max-height: 95vh !important; overflow-y: auto; width:100%; padding: 0px 12px 0px 0px;"
            >
              <div
                class="row justify-content-around align-items-center"
                Style="overflow-y:auto; overflow-x: hidden;"
              >
                <div class="row">
                  <!-- <div class="col-lg-3 col-md-6 col-sm-12  m-3" *ngFor="let item of newImageurllisting"> -->
                  <div
                    class="col-lg-4 col-md-4 col-sm-12"
                    *ngFor="let item of newImageurllisting"
                  >
                    <div style="position: relative">
                      <img
                        src="{{ item.imageUrl }}"
                        alt=""
                        class="gallery_images"
                      />
                      <mat-checkbox
                        style="position: absolute; top: -16px; right: -12px"
                        name="list_name"
                        [(ngModel)]="item.isSelected"
                      ></mat-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--This is image gallery-->
          </div>
        </div>

        <div
          class="row d-flex row"
          style="float: right; margin-top: -20px; padding: 0px"
        >
          <div class="col-md-9 col-sm-9 col-lg-9"></div>
          <div
            class="col-md-3 col-sm-3 col-lg-3 pull-right"
            style="margin-top: 30px; padding: 0px"
          >
            <!-- <button type="submit" mat-raised-button class="submit_button" color="primary"
              (click)="resetButton()">Reset</button>&nbsp; -->
            <button
              type="submit"
              class="submit_button"
              mat-raised-button
              color="primary"
              (click)="onSubmit()"
            >
              Publish
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!---==============================edit data html =================================================-->
</div>
